import { FC, useContext } from 'react';

import { ResumeCardActionsContext } from 'src/components/ResumeCard/Actions/Context';
import { useSelector } from 'src/hooks/useSelector';

import RemoveFromSuitableButton from 'src/components/ResumeCard/Actions/RemoveFromSuitableButton';

const RemoveFromSuitableButtonWrapper: FC<{ isMobile?: boolean }> = ({ isMobile }) => {
    const { resume, setHidden, isSuitableResume } = useContext(ResumeCardActionsContext);

    const vacancyId = useSelector(
        (state) =>
            (isSuitableResume && state.vacanciesShort.vacanciesList[0]?.vacancyId) ||
            state.resumeSearchResult.criteria?.vacancy_id
    );
    const isOtherEmployerVacancy = useSelector(
        (state) => state.resumeSearchResult?.vacancySimilarBuyContacts?.['@code'] === '403'
    );

    if (!vacancyId || isOtherEmployerVacancy) {
        return null;
    }

    return (
        <RemoveFromSuitableButton
            isMobile={isMobile}
            resumeId={resume._attributes.id}
            setHidden={setHidden}
            vacancyId={Number(vacancyId)}
        />
    );
};

export default RemoveFromSuitableButtonWrapper;
